import useAuth from "hooks/useAuth";
import get from "lodash-es/get";
import isArray from "lodash-es/isArray";

export default function useCheckPermissions() {
  const { permissions: storedPermissions = {} } = useAuth();
  return (permissions, atLeastOne = false) => {
    if (!permissions) return true;

    if (!isArray(permissions)) permissions = [permissions];

    const checkPermissions = atLeastOne ? "some" : "every";

    return permissions[checkPermissions]((permission) =>
      get(storedPermissions, permission, false),
    );
  };
}
